import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { environment } from '../../environments/environment';
import { enum_ErrorMessages } from '../_enums/errorMessage.enum';
import { throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { GlobalService } from './global.service';
import { ApiService } from './api.service';
import { PdfModel } from 'src/app/_models';
import { saveAs } from 'file-saver';

@Injectable()
export class PdfService {

    public isGeneratingSoA: boolean = false;

    constructor(private httpClient: HttpClient, private globalService: GlobalService, private apiService: ApiService) {
        //console.debug("PdfService().constructor()");
    }

    public print() {
        if (!this.isGeneratingSoA) {

            this.isGeneratingSoA = true;

            let empId = this.globalService.calculatorModel.members.current.memberNo; //this.apiService.getParameterByName('empId'); //this.globalService.calculatorModel.members.current.memberNo;
            let pdfModel = new PdfModel(this, empId);
            let dateTimeStamp = new Date();
            let filename = `Your-Qantas-Super-Report-${dateTimeStamp.getFullYear()}-${(dateTimeStamp.getMonth() + 1)}-${dateTimeStamp.getDate()}-${dateTimeStamp.getHours()}${dateTimeStamp.getMinutes()}${dateTimeStamp.getSeconds()}.pdf`;
            pdfModel.savePdf(filename);
        }
    }

    generate(pdfQueueKey: string) {
        console.debug('PdfService().generatePdf()');
        let pdfDate = new Date();
        let tUrl = environment.urls.pdfServiceGenerate;

        let empId = this.globalService.calculatorModel.members.current.memberNo;
        var url = environment.urls.host + '/' + environment.calculator.clientCode + '/' + environment.calculator.clientCalculator + '/' + environment.calculator.soAUrl;
        return this.httpClient.post(tUrl, {
            'referrerUrl': url,
            'pdfTitle': 'Testing Title',
            'pdfDate': pdfDate.toUTCString(),
            'calculatorModel': {
                'members': this.globalService.calculatorModel.members,
                'results': this.globalService.calculatorModel.results,
                'testingModel': this.globalService.calculatorModel.testingModel,
                'currentScenario': this.globalService.calculatorModel.currentScenario
            },
            'clientCode': environment.calculator.clientCode,
            'clientCalculator': environment.calculator.clientCalculator,
            'pdfQueueKey': pdfQueueKey,
            'empId': empId
        }, {
            responseType: 'blob'
        })
            .pipe(map((res) => {
                let blob = new Blob([res], {
                    type: 'application/pdf'
                });
                return blob;
            }))
            .pipe(catchError(this.handleError))
            .pipe(finalize(() => {
                //console.debug('PdfService().generatePdf() --> finalize');
                this.isGeneratingSoA = false;
            }));
    }

    getPdfModel(pdfQueueKey: string) {
        console.debug(`PdfService().getPdfModel(${pdfQueueKey})`);
        let pdfDate = new Date();
        let tUrl = environment.urls.pdfServiceGetPdfModel + '?pdfQueueKey=' + pdfQueueKey;

        return this.httpClient.get(tUrl, {
            observe: 'response'
        })
            .pipe(catchError(this.handleError))
            .pipe(finalize(() => {
                //console.debug('PdfService().getPdfModel() --> finalize');
                this.isGeneratingSoA = false;
            }));
    }

    setPdfModel() {
        console.debug(`PdfService().setPdfModel()`);
        let pdfDate = new Date();
        let tUrl = environment.urls.pdfServiceSetPdfModel;

        return this.httpClient.post(tUrl, {
            'referrerUrl': environment.urls.host + '/' + environment.calculator.clientCode + '/' + environment.calculator.clientCalculator + '/' + environment.calculator.soAUrl,
            'pdfTitle': 'Testing Title',
            'pdfDate': pdfDate.toUTCString(),
            'calculatorModel': {
                'members': this.globalService.calculatorModel.members,
                'results': this.globalService.calculatorModel.results,
                'testingModel': this.globalService.calculatorModel.testingModel,
                'currentScenario': this.globalService.calculatorModel.currentScenario
            },
            'clientCode': environment.calculator.clientCode,
            'clientCalculator': environment.calculator.clientCalculator
        }, {
            observe: 'response'
        })
            .pipe(catchError(this.handleError))
            .pipe(finalize(() => {
                //console.debug('PdfService().setPdfModel() --> finalize');
                //this.isGeneratingSoA = false;
            }));
    }

    private handleError(error: HttpErrorResponse) {
        //console.debug('PdfService().handleError()');
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }

        switch (error.status) {
            case 403:
                return throwError(enum_ErrorMessages.ERRORMESSAGE_403);
            case 404:
                return throwError(enum_ErrorMessages.ERRORMESSAGE_404);
            case 500:
                return throwError(enum_ErrorMessages.ERRORMESSAGE_500);
            default:
                return throwError(`${error.status} - ${error.error}`);
        }
    }
}
